<template>
<div class="sorting">
  <ui-button class="sort-btn" :disabled="keyFor==sort && direction=='desc'" @click="changeOrder(keyFor, 'desc')" icon="keyboard_arrow_down"></ui-button>
  <ui-button class="sort-btn" :disabled="keyFor==sort && direction=='asc'" @click="changeOrder(keyFor, 'asc')" icon="keyboard_arrow_up"></ui-button>
</div>

</template>
<script>
export default {
  props: ['sort', 'keyFor', 'direction'],
  methods: {
    changeOrder (sort, dir) {
      this.$emit('change-order', sort, dir)
    }
  }
}

</script>


// WEBPACK FOOTER //
// Sorting.vue?7a8c417a